// import { IBook } from "../../types/book";

export const calculateTotalProgress = (
  chapterProgressGroup,
  book
) => {
  if (!book.chapters) return 0;

  const progressValues = Object.values(chapterProgressGroup);
  const totalProgress = progressValues.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  const progressPercentage =
    (totalProgress / (book.chapters.length * 100)) * 100;

  return progressPercentage || 0;
};
